export const SETTINGS = {
  NAME: 'GraphQLClient',
};
